export function chunkArray(arr: Array<unknown>, chunkSize = 10) {
  return Array(Math.ceil(arr.length / chunkSize))
    .fill(null)
    .map((_, i) => arr.slice(i * chunkSize, i * chunkSize + chunkSize));
}
